export default async (url: string): Promise<string> => {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error("Failed to fetch file");
  }

  const blob = await res.blob();

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
